import { Box, Flex, Text, Toggle } from '@fullstory/components';
import { PaneProps } from '@fullstory/components/legacy/Pane';
import React from 'react';

type CollapsibleHeaderProps = PaneProps & {
  titleText: string;
  toggleText: string;
  onToggle: (value: boolean) => void;
  isCollapsed: boolean;
  /**
   * React node rendered to the left of the filter button
   */
  leftItem?: React.ReactNode;

  /**
   * React node rendered to the right of the filter button
   */
  rightItem?: React.ReactNode;
};

export const CollapsibleHeader: React.FC<CollapsibleHeaderProps> = ({
  titleText,
  toggleText,
  onToggle,
  isCollapsed,
  leftItem,
  rightItem,
}) => (
  <Box padding={24}>
    <Flex justifyContent="space-between">
      <Text appearance="bodyMedium">{titleText}</Text>
      <Flex gap={16}>
        {leftItem}
        <Toggle
          checked={!isCollapsed}
          onToggle={onToggle}
          testId="show-hide-definition"
          label={toggleText}
          labelPosition="right"
        />
        {rightItem}
      </Flex>
    </Flex>
  </Box>
);
